import React, { FC } from 'react';
import { Button, Toast } from '@10d/tend-ui/primitives';
import { DocumentDownloadOutline } from 'ui';
import { useSearch, useProfile } from 'hooks';

//
// Кнопка отправки Excel на почту пользователя
//
export const SendExcel: FC<Props> = ({ loading, disabled, onSend, text = 'Отправить Excel' }) => {
  const {
    profile: { email },
  } = useProfile();
  const { project, ...params } = useSearch();

  const onSendEmail = async () => {
    try {
      const reqData = {
        email,
        ...params,
        project: project || undefined,
        limit: undefined,
        page: undefined,
      };

      await onSend(reqData);

      Toast.success({
        message: reqData.email
          ? `Отчёт отправлен на почту: ${reqData.email}`
          : 'Отчёт отправлен на почту',
      });
    } catch (err) {
      console.error(err);
      Toast.error({
        message: 'Что-то пошло не так',
      });
    }
  };

  return (
    <Button
      variant='primary'
      before={<DocumentDownloadOutline />}
      disabled={disabled}
      loading={loading}
      onClick={onSendEmail}
    >
      {text}
    </Button>
  );
};

interface Props {
  onSend: (reqData: {
    [x: string]:
      | string
      | number
      | boolean
      | (string | number | boolean | null)[]
      | null
      | undefined;
  }) => void;
  disabled?: boolean;
  loading?: boolean;
  text?: string;
}
